import type { RouteRecordRaw } from 'vue-router'
import { DealsRoutes } from '@/routes/user/deals/types'
import { getDealsPipelineRoutes } from '@/routes/user/deals/dealsPipelines'
import { AppModule } from '@/config/types'
import { getOldDealsSettingsRoute } from '@/routes/user/deals/oldDealsSettings'

export const getDealsRoutes = (): RouteRecordRaw[] => [
  {
    name: DealsRoutes.index,
    path: 'deals',
    props: true,
    meta: {
      tags: ['USER_TOP_MENU'],
      tabTitle: 'pageTitle.user.deals.deals',
      modules: [AppModule.Deals],
    },
    redirect: { name: DealsRoutes.base },
    component: () => import('@/components/views/deals/Deals.vue'),
    children: [...getDealsPipelineRoutes()],
  },
  getOldDealsSettingsRoute(),
]
